<script>
import moment from "moment";
import { apiService } from '@/helpers/api.service'
import Swal from "sweetalert2"
import { daysOfWeek } from '@/utils/utilsDate';

    export default {
        props: {
            isOpen: {
                type: Boolean,
                default: null,
            },
            isVisible: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                titleOpen: '¿Cerrar el restó?',
                titleClose: '¿Deseas abrir el restó?',
                descriptionOpen: 'Mientras esté cerrado, tus clientes no podrán realizar órdenes.',
                descriptionClose: 'Tus clientes podrán disfrutar de tus platos.',
                isScheduleEmpty: true,
                today: '',
                open: undefined, 
            };
        },
        watch: {
        isVisible: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.StoreWeekend();
                }
            },
        },
        schedule: {
            deep: true,
        }
    },
        mounted() {
            this.Today()
            this.StoreWeekend()
            this.open = (JSON.parse(localStorage.getItem('user')).isAvailable)
        },
        methods: {
            Today() {
            this.nameToday = moment.utc().format('dddd');
            const indexToday = daysOfWeek.indexOf(this.nameToday);
            this.today = indexToday;
        },
        StoreWeekend() {
            this.isVisible &&  this.$bvModal.show('schedule')
            apiService.getStoreById().then((store) => {
                this.weekend = store;
                if (this.weekend.schedule != null) {
                    this.scheduleFilter = this.weekend.schedule.filter(item => item.day === this.today);
    
                    this.schedule = this.scheduleFilter.map(item => {
                        return {
                            ...item,
                            isOpen: item.isAvailable
                        };
                    });
                } else {
                    this.isScheduleEmpty = false
                }
            }).catch(() => {
                this.isScheduleEmpty = false
            })
        },
        patchDay() {
            let updatedSchedule = {
                schedule: {
                    day: this.schedule[0].day,
                    hours: this.schedule[0].hours.map(hour => ({
                        open: hour.open,
                        close: hour.close
                    })),
                    isAvailable: !this.isOpen
                },
                isOpen: !this.isOpen
            };

            apiService.patchScheduleDay(updatedSchedule)
                .then((res) => {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Guardado con éxito.",
                        showConfirmButton: false,
                        timer: 4500
                    });
                    localStorage.setItem('store', JSON.stringify(res.data));
                    window.location.reload();
                })
                .catch(() => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Ocurrio un error al guardar el horario.",
                        showConfirmButton: false,
                        timer: 4500
                    });
                })
                .finally(() => {
                    this.$emit('close');
                    this.$bvModal.hide('schedule')
                })
        },
        handleCancel() {
            this.$emit('close');
            this.$bvModal.hide('schedule')
        },
        redirectToSchedule() {
            this.$emit('close');
            this.$bvModal.hide('schedule')
            window.location.href = '/welly/schedule';
        },
        handleHidden() {
            this.$emit('close');
            this.$bvModal.hide('schedule')
        },
        },
    }
</script>

<template>
    <div v-if="isVisible" class="stateConfirmPopUpContainer">
        <p> <span>{{ this.isOpen ? titleOpen : titleClose }} </span> {{ this.isOpen ? descriptionOpen : descriptionClose }}</p>
        <div class="stateConfirmPopUpBtn">
            <button v-if="!isScheduleEmpty" @click="redirectToSchedule">Cargar Horarios</button>
            <button v-else @click="patchDay" class="state-btn">Aceptar</button>
            <button @click="handleCancel()">Cancelar</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/components/state-confirm-popup';
</style> 